import { SEO_TITLE_USERS_DIRECTORY, USERS_DIRECTORY_SEARCH } from 'mk/autogenerated/translations/UsersDirectoryPage.907bab1ba48747c1a0deeb568ae393c7'
import { UsersDirectoryFormData } from 'mk2/apps/users/components/UsersDirectoryForm';
import UsersDirectory from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory';
import { usersDirectorySearchTrigger } from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.actions';
import { USERS_DIRECTORY_FORM_NAME } from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.constants';
import usersDirectoryReducer from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.reducers';
import usersDirectorySaga from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.sagas';
import { getUsersDirectoryState } from 'mk2/apps/users/containers/UsersDirectory/UsersDirectory.selectors';
import { UserStatsEntity, UserStatsSchema } from 'mk2/apps/users/schemas';
import { SubmitButton } from 'mk2/components/forms/SubmitButton';
import { AppName } from 'mk2/containers/Application/Application';
import { mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/decorators/mkReduxForm';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { getRequestDeviceMobile, AppState } from 'mk2/reducers';
import { HeaderMenuItem, MenuSelection } from 'mk2/schemas';
import { getDenormalizedEntities } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { getFormValues } from 'redux-form';

interface OwnProps {}

interface StateProps extends FormPageStateProps {
    usersStats: UserStatsEntity[];
    hasMore: boolean;
    isMobile: boolean;
    initialValues: UsersDirectoryFormData;
    currentValues: UsersDirectoryFormData;
}

interface DispatchProps extends FormPageDispatchProps {
    onSearch(values: UsersDirectoryFormData);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class UsersDirectoryPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const q = parse(ownProps.location.search, { parseNumbers: true });
            const usersDirectoryState = getUsersDirectoryState(state);
            const usersStats = getDenormalizedEntities<UserStatsEntity>(state, UserStatsSchema, usersDirectoryState.usersStatsIds);
            return {
                ...mkReduxFormMapStateToProps(USERS_DIRECTORY_FORM_NAME)(state),
                usersStats,
                hasMore: usersDirectoryState.hasMore,
                isMobile: getRequestDeviceMobile(state),
                initialValues: {
                    login: '',
                    dueDate: '',
                    county: (q.county as number) || null,
                    place: null,
                    orderBy: '-last_login_time',
                },
                currentValues: getFormValues(USERS_DIRECTORY_FORM_NAME)(state) as UsersDirectoryFormData,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(USERS_DIRECTORY_FORM_NAME),
            onSearch: usersDirectorySearchTrigger,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_USERS_DIRECTORY;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <UsersDirectory {...props} />
        );
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: 'photoblog',
            activeItem: HeaderMenuItem.BlogsUsersDirectory,
        };
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getSubmitButton(props: Props): React.ReactElement {
        return (
            <SubmitButton
                label={USERS_DIRECTORY_SEARCH}
                formName={USERS_DIRECTORY_FORM_NAME}
            />
        );
    }

    public getFooter(props: Props): boolean {
        return false;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.users.usersDirectory', usersDirectoryReducer);
        store.injectSaga('containers.users.usersDirectory', usersDirectorySaga);
    }
}
